var _module_exports ="<div class=\"followup-list\">\n\n    <h4>{{'Comments' | t}}</h4>\n\n    <div follow-up\n         box-model=\"boxModel\"\n         box-tmpl=\"list\"></div>\n</div>";;
var path = '/app/shared/BCM/BIAProfile/biaProfileFollowUp.list.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;